import { TNotFoundRequestError } from '@/types/not-found-request-error';

const isNotFoundRequestError = (error: unknown): unknown =>
  error && (error as TNotFoundRequestError)?.error.status === 404;

export default isNotFoundRequestError;
